import { useRef } from 'react';

import { staticImageUrl } from '../../util/images';
import {
  smallShareButtonStyle,
  smallTextStyle,
  smallLogoStyle,
  shareButtonStyle,
  textStyle,
  logoStyle,
  smallLinkStyle,
  linkStyle,
} from '../../style/shareButtonStyles';
import track from '../../lib/events';

const facebook = staticImageUrl('facebook.png');

const FacebookShare = ({
  url = 'projectwren.com',
  name = '',
  size,
  button,
  className,
  campaignName = 'share',
  utmMedium = name,
}: {
  url: string;
  name: string;
  size?: 'small';
  button?: React.ReactNode;
  className?: string;
  campaignName?: string;
  utmMedium?: string;
}) => {
  const anchorRef = useRef<HTMLAnchorElement>(null);

  const urlObj = new URL(url);
  urlObj.searchParams.set('utm_source', 'facebook-organic');
  urlObj.searchParams.set('utm_campaign', campaignName);
  urlObj.searchParams.set('utm_medium', utmMedium);

  const encodedUrl = urlObj.toString();

  const handleOpenPopup = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    track('Server: User Clicked Share Button', {
      name,
      source: 'facebook',
      campaignName,
      utmMedium,
    });
    window.open(
      anchorRef.current?.href || '',
      'facebook',
      'left=20,top=20,width=500,height=500,toolbar=1,resizable=0'
    );
    return false;
  };

  return (
    <a
      href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&hashtag=%23climatechange`}
      onClick={(e) => handleOpenPopup(e)}
      ref={anchorRef}
      rel="noreferrer noopener"
      target="_blank"
      css={size === 'small' ? smallLinkStyle : linkStyle}
      className={className}
    >
      {button || (
        <button
          css={size === 'small' ? smallShareButtonStyle : shareButtonStyle}
        >
          <img
            src={facebook}
            alt=""
            css={size === 'small' ? smallLogoStyle : logoStyle}
          />
          <p css={size === 'small' ? smallTextStyle : textStyle}>Facebook</p>
        </button>
      )}
    </a>
  );
};

export default FacebookShare;
